// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kk-0";
export var fileCarousel = "_kk-2";
export var removeFileButton = "_kk-1";